// extracted by mini-css-extract-plugin
module.exports = {"root":"LARDBHeader_root__2w_q8","leftPart":"LARDBHeader_leftPart__cHd-O","rightPart":"LARDBHeader_rightPart__m8kpj","notesButton":"LARDBHeader_notesButton__1D6UC"};